import {expectOneOf, HttpClient, useHttpClient} from '@raison/network-facade';
import {queryOptions} from '@tanstack/react-query';
import {type} from 'arktype';
import {useAtomValue} from 'jotai';
import {Logout$, SessionExpiredError} from '~/entities/user';

export async function fetchVaspOptions(http: HttpClient) {
    return http('v1/travel_rule/vasp').then(
        expectOneOf({
            200: type({
                items: VaspSchema.array(),
            }),
            401: null,
        })
    );
}

const VaspSchema = type({
    id: 'string',
    name: 'string',
});

export function useVaspListOptions() {
    const http = useHttpClient();
    const logout = useAtomValue(Logout$);
    const {queryKey, queryFn, gcTime} = queryOptions({
        queryKey: ['v1/travel_rule/vasp'],
        async queryFn() {
            const response = await fetchVaspOptions(http);
            switch (response.status) {
                case 200:
                    return response.json;
                case 401:
                    logout();
                    throw new SessionExpiredError();
            }
        },
        gcTime: Infinity,
    });
    return {queryKey, queryFn, gcTime};
}
